<script>

const isToday = (someDate) => {
	const today = new Date()
	return someDate.getDate() == today.getDate() &&
		someDate.getMonth() == today.getMonth() &&
		someDate.getFullYear() == today.getFullYear()
}

const leadingZero = (num) => `0${num}`.slice(-2);

const formatTime = (date) =>
	[date.getHours(), date.getMinutes()]
	.map(leadingZero)
	.join(':');

	const mixin = {
		methods: {
			getAsset: name => `@/${name}`,

			formatDate: (date) => {
				let datum = new Date(date);

				let today = isToday(datum);

				if(today) {
					return `vandaag ${formatTime(datum)}`;
				}

				const options = {  
					month: 'long', 
					day: 'numeric', 
				};

				return datum.toLocaleDateString('nl-NL', options);
			}
		}
	};

export default mixin;

</script>
